import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ChangementCoordonneeCreditAccesDService } from '../../../services/changement-coordonnee-credit-accesd/changement-coordonnee-credit-acces-d.service';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { AccessibiliteService } from '../../../services/accessibilite.service';
import { ErreurMappingService } from '../../../services/errors/erreur-mapping.service';
import { TypeChangementEnum } from '../../../constantes/type-changement.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../../models/cybermetrie/cybermetrie.enum';
import typeErreurEnum from '../../../constantes/type-erreur.enum';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { SpinnerService } from '../../../services/spinner.service';
import { StateValidation } from '../../../models/state/state-validation.model';
import { RequeteModifierCoordonnees } from 'src/app/api/model/requete-modifier-coordonnees.model';
import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { Telephones } from 'src/app/api/model/telephones.model';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';

const SUCCES = 'succes';
const ERREUR = 'erreur';
const LIMITE_JOURNALIERE = 'erreurLimiteJournaliere';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  standalone: false,
})
export class ValidationComponent implements OnInit {
  requeteModifierCoordonnees: RequeteModifierCoordonnees;

  typeChangement: string;
  titre: string;
  compteActif?: CompteDetention;
  comptesDetentionInitial?: CompteDetention[] = [];
  telephones?: Telephones[] = [];
  state: StateValidation;
  isAppMobile: boolean;

  constructor(
    protected navigationService: NavigationService,
    protected globalStoreService: GlobalStoreService,
    protected accessibiliteService: AccessibiliteService,
    protected erreurMappingService: ErreurMappingService,
    protected changementCoordonneeAccesd: ChangementCoordonneeCreditAccesDService,
    protected gestionTitreService: GestionTitreService,
    protected spinnerService: SpinnerService,
    protected cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    private readonly gabaritService: GabaritService,
    router: Router
  ) {
    this.state = router.lastSuccessfulNavigation?.extras?.state as StateValidation;
  }

  ngOnInit(): void {
    this.isAppMobile = this.gabaritService.isAppMobile();
    if (this.state?.type != null) {
      this.typeChangement = this.state.type;
      this.compteActif = this.state.compteDetention;
      this.telephones = this.state.telephones ?? [];
      this.comptesDetentionInitial = this.state.comptesDetentionInitial ?? [];
      localStorage.setItem('typeChangement', this.typeChangement);
    } else {
      this.typeChangement = localStorage.getItem('typeChangement');
    }
    this.accessibiliteService.setFocus('h2');
    this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_ETAPE,
      CybermetrieEnum.LABEL_MODIFIER_INFOS,
      0,
      this.typeChangement
    );
    this.globalStoreService.getUpdateDataForm().subscribe((requeteModifierCoordonnees) => {
      this.requeteModifierCoordonnees = requeteModifierCoordonnees;
    });
    this.titre = this.getTitre();
    this.gestionTitreService.addTitreOnglet(this.getTitreOnglet());
  }

  protected isCoordonnees(): boolean {
    return this.typeChangement === TypeChangementEnum.COORDONNEES;
  }

  protected isCourriel() {
    return this.typeChangement === TypeChangementEnum.COURRIEL;
  }

  protected isTelephone() {
    return this.typeChangement === TypeChangementEnum.TELEPHONE;
  }

  private getTitre(): string {
    switch (this.typeChangement) {
      case TypeChangementEnum.COURRIEL:
        return 'caad.modifier.courriel.' + this.getTitreCourriel();
      case TypeChangementEnum.TELEPHONE:
        return 'caad.modifier.telephone.' + this.getTitreTelephone();
      default:
        return 'caad.modifier.coordonnees.titre';
    }
  }

  private getTitreOnglet(): string {
    switch (this.typeChangement) {
      case TypeChangementEnum.COURRIEL:
        return 'caad.titreOnglet.validation.COURRIEL.' + this.getTitreCourriel();
      case TypeChangementEnum.TELEPHONE:
        return 'caad.titreOnglet.validation.TELEPHONE.' + this.getTitreTelephone();
      default:
        return 'caad.titreOnglet.validation.COORDONNEES';
    }
  }

  private getTitreTelephone(): string {
    const numberOfTelephones = this.telephones?.length ?? 0;
    switch (numberOfTelephones) {
      case 0:
        return 'titreAjout';
      case 1:
        return 'titre';
      default:
        return 'titreTelephones';
    }
  }

  private getTitreCourriel(): string {
    let libelle = 'titreAjout';
    if (
      this.compteActif
        ? this.compteActif.infosCompte.adresseCourriel
        : this.comptesDetentionInitial?.[0].infosCompte.adresseCourriel
    ) {
      libelle = 'titre';
    }
    return libelle;
  }

  annulerModification() {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  retourForm() {
    this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_GESTION_CARTE,
      CybermetrieEnum.ACTION_CLIC,
      CybermetrieEnum.LABEL_MODIFIER_VALIDATION,
      0,
      this.typeChangement
    );
    switch (this.typeChangement) {
      case TypeChangementEnum.COORDONNEES:
        this.navigationService.naviguerVersModificationCredit();
        break;
      case TypeChangementEnum.COURRIEL:
        this.navigationService.naviguerVersModificationCourrielCredit(this.compteActif);
        break;
      case TypeChangementEnum.TELEPHONE:
        this.navigationService.naviguerVersModificationTelephoneCredit();
        break;
      default:
        this.navigationService.naviguerVersCredit();
    }
  }

  submit() {
    // Pour mettre le focus sur l'alerte
    this.globalStoreService.saveSelector('dsd-alert');
    const nbTelephone = this.requeteModifierCoordonnees.telephones
      ? this.requeteModifierCoordonnees.telephones.length
      : 0;
    this.changementCoordonneeAccesd.patchCoordonnee$(this.requeteModifierCoordonnees, this.typeChangement).subscribe({
      next: () => {
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_COMPLETE,
          CybermetrieEnum.LABEL_MODIFIER_INFOS,
          nbTelephone,
          this.typeChangement
        );
        this.basicSubmitPath(SUCCES);
      },
      error: (e) => {
        const codeErreur = e?.error?.errors[0]?.code;
        const erreurModification = codeErreur === typeErreurEnum.LIMITE_JOURNALIERE ? LIMITE_JOURNALIERE : ERREUR;
        this.basicSubmitPath(erreurModification);
      },
    });
  }

  basicSubmitPath(etat: string) {
    this.globalStoreService.saveCoordonneesClient(null);
    this.globalStoreService.saveEtatModification(etat);
    this.globalStoreService.saveUpdateDataForm(null);
    this.erreurMappingService.resetFormsError();
    this.navigationService.naviguerVersCredit();
  }
}
